<template>
  <section class="p-4 bg-key rounded-4xl">
    <div>
      <h3 class="text-l-medium text-black-white">
        {{ $t('performance.keyboard.debounce.title') }}
      </h3>
      <p class="mt-1 text-s-medium text-text-glass-default">
        {{ $t('performance.keyboard.debounce.description') }}
      </p>
    </div>

    <div class="mt-3">
      <div
        class="flex items-center gap-0.5 bg-neutral-light-active h-4 rounded-3xl overflow-hidden"
      >
        <div
          v-for="option in options"
          :key="option.value"
          class="flex-1 h-full cursor-pointer transition-colors"
          :class="
            model === option.value ? 'bg-brand-blue1' : 'bg-shadow15 hover:bg-blue-dark-hover'
          "
          @click="model = option.value"
        />
      </div>
      <div class="py-1 w-full flex items-center justify-between">
        <span class="text-l-medium text-black-white">
          {{ $t('performance.keyboard.debounce.low') }}
        </span>
        <span class="text-l-medium text-black-white">
          {{ $t('performance.keyboard.debounce.high') }}
        </span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { KeyboardPerformanceOption } from '../types'

  const model = defineModel<string>({ required: true })

  const options: KeyboardPerformanceOption[] = Array.from({ length: 8 }, (_, level) => ({
    label: String(level),
    value: String(level),
  }))
</script>
